import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";

const ProtectedRoute = () => {
  const accessToken = sessionStorage.getItem("accessToken");
  const selectedLocationId = localStorage.getItem("selectedLocationId");
  const selectedSystemId = localStorage.getItem("selectedSystemId");
  const location = useLocation();

  if (!accessToken) {
    return <Navigate to="/login" replace />;
  }

  if (location.pathname === "/facility") {
    return <Outlet />;
  }

  if (!selectedLocationId || !selectedSystemId) {
    return <Navigate to="/facility" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;
